import React from "react";
import PropTypes from "prop-types";
import { Badge } from "reactstrap";

const JobsBadge = ({ status }) => {
  const getColor = (status) => {
    switch (status) {
      case "active":
        return "success";
      case "inactive":
        return "danger";
        case "applied":
          return "success";
          case "accepted":
          return "success";
          case "rejected":
          return "danger";
          case "Currently not accepting applications.":
            return "warning"
      default:
        return "primary";

    }
  };

  return (
    <Badge color={getColor(status)} className="rounded-pill px-3 p-1">
      {status}
    </Badge>
  );
};

JobsBadge.propTypes = {
  status: PropTypes.oneOf(["active", "inactive"]).isRequired,
};

export default JobsBadge;
